module.exports = __webpack_public_path__ + "img/容器 2739.4261dd88.png";